import { useEffect, useState } from 'react';
import type { SizeGuideType } from '../types';

type GetSizeGuideProps = {
  locale: string;
  gender: string[] | undefined;
  type: string;
};

export const useGetSizeGuide = () => {
  const [sizeGuide, setSizeGuide] = useState([] as SizeGuideType[]);
  const [isSizeGuideOpen, setIsSizeGuideOpen] = useState(false);
  const [isCalled, setIsCalled] = useState(false);

  const getSizeGuide = async ({ gender, locale, type }: GetSizeGuideProps) => {
    try {
      if (isCalled) return;
      const body = JSON.stringify({
        gender,
        locale,
        type,
      });

      const result = await fetch('/api/size-guide', {
        method: 'POST',
        body,
      });
      const { sizeGuide: data } = await result.json();
      setSizeGuide(data);
    } catch (e) {
      console.error(e);
    } finally {
      setIsSizeGuideOpen((prev) => !prev);
      setIsCalled(true);
    }
  };

  useEffect(() => {
    document.body.style.overflow = isSizeGuideOpen ? 'hidden' : 'initial';
  }, [isSizeGuideOpen]);

  return { getSizeGuide, sizeGuide, isSizeGuideOpen, setIsSizeGuideOpen, setIsCalled, isCalled };
};
